import React from "react";
import { Settings, Clock } from "lucide-react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../components/ui/card";
import ProvisioningForm from "../components/ProvisioningForm";
import ShiftOSProvisioningForm from "../components/ShiftOSProvisioningForm";

const Provision = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-blue-50/30 p-3 lg:p-6">
      <div className="max-w-7xl mx-auto space-y-6 lg:space-y-8 w-full overflow-hidden">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <div className="space-y-1">
            <h1 className="text-2xl lg:text-3xl font-bold text-gray-900">
              Provision
            </h1>
            <p className="text-sm lg:text-base text-gray-600">
              Create and manage new accounts
            </p>
          </div>
        </div>

        {/* Ardorio Provisioning Form */}
        <Card className="bg-white/80 backdrop-blur-sm border-0 shadow-xl shadow-gray-200/50 rounded-2xl">
          <CardHeader className="pb-4 lg:pb-6">
            <CardTitle className="flex items-center gap-2 lg:gap-3 text-lg lg:text-xl">
              <div className="w-8 h-8 lg:w-10 lg:h-10 bg-gradient-to-br from-green-500 to-green-600 rounded-xl flex items-center justify-center shadow-lg shadow-green-500/25">
                <Settings className="h-4 w-4 lg:h-5 lg:w-5 text-white" />
              </div>
              <span className="text-base lg:text-xl">
                Provision New Ardorio Account
              </span>
            </CardTitle>
          </CardHeader>
          <CardContent className="p-6 lg:p-8">
            <ProvisioningForm />
          </CardContent>
        </Card>

        {/* ShiftOS Provisioning Form */}
        <Card className="bg-white/80 backdrop-blur-sm border-0 shadow-xl shadow-gray-200/50 rounded-2xl">
          <CardHeader className="pb-4 lg:pb-6">
            <CardTitle className="flex items-center gap-2 lg:gap-3 text-lg lg:text-xl">
              <div className="w-8 h-8 lg:w-10 lg:h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center shadow-lg shadow-blue-500/25">
                <Clock className="h-4 w-4 lg:h-5 lg:w-5 text-white" />
              </div>
              <span className="text-base lg:text-xl">
                Provision New ShiftOS Account
              </span>
            </CardTitle>
          </CardHeader>
          <CardContent className="p-6 lg:p-8">
            <ShiftOSProvisioningForm />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Provision;
